module.exports = __webpack_public_path__ + "static/media/hotel.75458f5c.png";